module.exports = __webpack_public_path__ + "static/media/three-line-close.6a1106c8.svg";